<div class="att-list-page">
    <header class="page-head">
        <button type="button" class="back-link" (click)="onBack()">
            <i-feather name="arrow-left"></i-feather>{{ 'Back to sessions' | translate }}
        </button>
        <div class="page-head__row">
            <div>
                <h1 class="page-title">
                    {{ 'Attendance' | translate }}
                    @if (sessionDate) {
                        <span class="page-title__date">· {{ isDateValue(sessionDate) ? (sessionDate | date:'EEEE, d MMM y') : sessionDate }}</span>
                    }
                </h1>
                @if (activityName) {
                    <p class="page-subtitle">{{ activityName }}</p>
                }
            </div>
            <div class="head-actions">
                <button type="button" class="action-btn action-btn-export head-btn" (click)="onDownloadTemplate()">
                    <i-feather name="download"></i-feather>{{ 'Generate Excel Template' | translate }}
                </button>
                @if (canEdit) {
                    <button type="button" class="action-btn action-btn-edit head-btn" (click)="onUploadExcel()">
                        <i-feather name="upload"></i-feather>{{ 'Upload Attendance' | translate }}
                    </button>
                }
            </div>
        </div>
    </header>

    <section class="card-plain">
        <div class="toolbar">
            <div class="counts">
                <span class="count"><span class="dot dot--present"></span><strong>{{ presentCount }}</strong> {{ 'Present' | translate }}</span>
                <span class="count"><span class="dot dot--absent"></span><strong>{{ absentCount }}</strong> {{ 'Absent' | translate }}</span>
                @if (unmarkedCount > 0) {
                    <span class="count"><span class="dot dot--unmarked"></span><strong>{{ unmarkedCount }}</strong> {{ 'Not marked' | translate }}</span>
                }
            </div>
            @if (canEdit && attendanceList.length) {
                <button type="button" class="link-btn" (click)="markAll('present')" [disabled]="saving">{{ 'Mark all present' | translate }}</button>
            }
        </div>

        @if (totalNewParticipant > 0) {
            <p class="note">{{ totalNewParticipant }} {{ 'student(s) joined after this attendance was created. Mark them before saving.' | translate }}</p>
        }

        @if (loading) {
            <p class="empty">{{ 'Loading students…' | translate }}</p>
        } @else if (!attendanceList.length) {
            <p class="empty">{{ 'No students in this session.' | translate }}</p>
        } @else {
            <table mat-table [dataSource]="attendanceList" matSort (matSortChange)="sortAttendanceList($event)" class="student-table">
                <ng-container matColumnDef="student_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="student_name">{{ 'Student Name' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span class="student-name">{{ element.student_name }}</span>
                        <span class="student-class">{{ element.class_name }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="class_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="class_name" class="cell-class">{{ 'Class' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-class">{{ element.class_name }}</td>
                </ng-container>

                <ng-container matColumnDef="attendance">
                    <th mat-header-cell *matHeaderCellDef class="cell-toggle">{{ 'Attendance' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="cell-toggle">
                        <button type="button" role="switch" class="att-switch"
                            [class.is-present]="element.status === 'present'"
                            [class.is-absent]="element.status === 'absent'"
                            [attr.aria-checked]="element.status === 'present'"
                            [attr.aria-label]="element.student_name"
                            [disabled]="!canEdit || saving"
                            (click)="toggleStatus(element)">
                            <span class="att-switch__track"><span class="att-switch__thumb"></span></span>
                            <span class="att-switch__label">
                                @switch (element.status) {
                                    @case ('present') { {{ 'Present' | translate }} }
                                    @case ('absent') { {{ 'Absent' | translate }} }
                                    @default { {{ 'Not marked' | translate }} }
                                }
                            </span>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
            </table>
        }

        <footer class="form-footer">
            <span class="form-footer__hint">
                @if (isDirty) {
                    {{ 'Unsaved changes' | translate }}
                }
            </span>
            <div class="form-footer__actions">
                <button type="button" class="action-btn action-btn-edit" (click)="onBack()" [disabled]="saving">{{ 'Cancel' | translate }}</button>
                @if (canEdit) {
                    <button type="button" class="action-btn action-btn-create" (click)="onSaveAttendance()" [disabled]="saving || loading">
                        {{ (saving ? 'Saving…' : 'Save') | translate }}
                    </button>
                }
            </div>
        </footer>
    </section>
</div>

<ng-template #uploadTemplate let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'Upload Attendance' | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p class="upload-hint">{{ 'Fill in the Excel template, then drop it here.' | translate }}</p>
        <ngx-dropzone (change)="uploadExcel($event)" [multiple]="false" [disabled]="loadExcel"
            [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'">
            <ngx-dropzone-label>
                <div class="d-flex flex-column align-items-center justify-content-center gap-2">
                    <i-feather name="upload"></i-feather>
                    <span>{{ 'Drag and drop the Excel file here, or click to choose' | translate }}</span>
                </div>
            </ngx-dropzone-label>
        </ngx-dropzone>
    </div>
</ng-template>
